import React, {
  useCallback, useRef,
} from 'react';

import { useTwFidgetFactory } from '@/tracking/twitter/utils';
import { SubscriberDataEvent, useAnalytics } from '@/tracking/analytics';
import { useReadyOnWebOnly } from '@/util/useReadyOnWebOnly';
import { Timeline } from '@/tracking/twitter/widgets';
import { SectionCard } from '@/components/ui/section-card';

/**
 * @see https://github.com/andrewsuzuki/react-twitter-widgets/issues/45
 */
export const Twitter = ({ feed }: { feed: string }) => {
  const a = useAnalytics();
  const div = useRef<HTMLDivElement>(null);
  const ready = useReadyOnWebOnly();

  const onTwitterClick = useCallback(() => {
    a.subcriberEvent(SubscriberDataEvent.HomePageClick, { url: `https://twitter.com/${feed}` });
  }, [a, feed]);

  const twWidgets = useTwFidgetFactory();

  if (!ready || !twWidgets) {
    return null;
  }

  return (
    <SectionCard as="article" padding="none" className="overflow-hidden">
      <header className="border-b border-border bg-muted/40 px-5 py-3 text-right text-sm">
        <a href={`https://twitter.com/${feed}`} onClick={onTwitterClick}>
          @
          {feed}
        </a>
      </header>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div className="overflow-hidden p-3 pb-0" onClick={onTwitterClick} ref={div}>
        <Timeline
          dataSource={{
            sourceType: 'profile',
            screenName: feed,
          }}
          options={{
            height: '400',
            noheader: true,
            nofooter: true,
            noborders: true,
            borderColor: '#FFFFFF',
            'tweet-limit': 1,
            tweetLimit: 1,
            id: `profile:${feed}`,
            chrome: 'noheader nofooter noborders transparent noscrollbar',
          }}
        />
      </div>
    </SectionCard>
  );
};
